export type CookieConsent = 'granted' | 'denied';

export const COOKIE_CONSENT_STORAGE_KEY = 'cookieConsent';

export function getCookieConsent(): CookieConsent | null {
  if (typeof window === 'undefined') return null;

  try {
    const value = window.localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    return value === 'granted' || value === 'denied' ? value : null;
  } catch {
    return null;
  }
}

export function setCookieConsent(consent: CookieConsent) {
  if (typeof window === 'undefined') return;

  try {
    window.localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, consent);
  } catch {
    // Ignore storage errors (e.g. private browsing) and apply the choice for this session only
  }

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', { analytics_storage: consent });
  }
}
